/** @jsx jsx */
import { jsx } from 'theme-ui'
import Grid from '../helpers/grid.jsx'
import {
  AwardLabel,
  CupIcon,
  PeopleIcon,
  DatabaseIcon
} from '../winners/moreInfoConfig.jsx'
import NomineeCard from './NomineeCard.jsx'
import Heading from '../helpers/heading.jsx'
import Subheading from '../helpers/subheading.jsx'

export const PUBLIC_CHOICE = () => (
  <AwardLabel icon={PeopleIcon} title="Public choice" bgColor="#50F094" />
)

export const JUDGES_CHOICE = () => (
  <AwardLabel icon={CupIcon} title="Judges' choice" bgColor="#79C3FF" />
)

export const OPENSIGNAL_CHOICE = () => (
  <AwardLabel icon={DatabaseIcon} title="Opensignal data" bgColor="#FFA08B" />
)

const primaryNominees = [
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Best Telecoms Innovation',
    nomineeNames: ['EE', 'Fibrus', 'Talk Talk']
  },
  {
    awardlabel: <JUDGES_CHOICE />,
    category: 'Best Refurbished Device Seller',
    nomineeNames: ['Music Magpie', 'Mozillion', 'Back Market']
  }
]

const IndustrySection = ({ children }) => (
  <div>
    <Subheading>Industry</Subheading>
    <Grid gridTemplateColumns={['1fr', '1fr', 'repeat(2, 1fr)']}>
      {primaryNominees.map((nominee) => (
        <NomineeCard key={nominee.category} {...nominee} />
      ))}
    </Grid>
  </div>
)

export default IndustrySection
